export default __webpack_public_path__ + "static/media/Toupup.0c07adaf.gif";